import { Injectable } from '@angular/core'
import { GuardResult } from '@angular/router'
import { CHECKOUT_FEATURE } from '@spartacus/checkout/base/root'
import { FeatureModulesService } from '@spartacus/core'
import { from, Observable } from 'rxjs'
import { switchMap } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class EbCheckoutEntryGuard {
  constructor(private readonly featureModules: FeatureModulesService) {}

  canActivate(): Observable<GuardResult> {
    return this.featureModules
      .resolveFeature(CHECKOUT_FEATURE)
      .pipe(
        switchMap(moduleRef =>
          from(import('@spartacus/checkout/base/components')).pipe(
            switchMap(({ CheckoutGuard }) => moduleRef.injector.get(CheckoutGuard).canActivate())
          )
        )
      )
  }
}
